<section class="deadline-table-b" id="deadline-table" *ngIf="showDeadline" #containerDeadline>
  <div class="deadline-table_header">
    <h1 class="title">Plazos</h1>
    <p class="descp">Elige el plazo que mejor se adapte a tus necesidades.</p>
  </div>
  <div class="container-btn-autorize">
    <button (click)="preauthorize()" [disabled]="resultOfRequestNotSuccess() || !deadlineSelect" mat-raised-button
      id="boton-autorizar-plan{{isAfin ? '-rent2buy' : ''}}">¡QUIERO AUTORIZAR MI PLAN!</button>
  </div>

  <div class="content-loader" *ngIf="loadingDeadline || deadlines.length === 0;else showDeadlineTable">
    <app-loading-spinner></app-loading-spinner>
  </div>
  <ng-template #showDeadlineTable>

    <div class="container-table mt-20" #table>
      <ng-container *ngFor="let deadline of deadlines; index as i">
        <div class="container-column" [ngClass]="{'reduce-margin': deadline.title === 'afin' && i === 0}"
          *ngIf="!deadline.hide">
          <div class="title-column" [ngClass]="{'hidde-title': deadline.title === 'afin' && i === 1}">
            <span class="title" [ngClass]="{'credit': deadline.title === 'traditional'}">
               Crédito {{deadline.title === typeProduct.Traditional ? '' : 'Balloon'}}
            </span>

            <div class="tooltip-custom">
              <img class="icon-info" id="boton-info-{{deadline.title}}" src="./assets/img/icon-info.svg" alt="img-info"
              [ngxTippy]="creditTooltip" [tippyProps]="tippyProps" tippyClassName="body-custom-tool">
              <!-- <img class="icon-info" id="boton-info-{{deadline.title}}" src="./assets/img/icon-info.svg" alt="img-info" *ngIf="!deadline.title.includes('crédito')"
                [ngxTippy]="planes[deadline.title].tooltip" [tippyProps]="tippyProps" tippyClassName="body-custom-tool"> -->

              <!-- <img class="icon-play" id="boton-play-video-{{deadline.title}}" src="./assets/home/play.svg" *ngIf="!deadline.title.includes('crédito')"
                alt="img-play"
                (click)="summaryService.openVideo(planes[deadline.title].video, 'Video info ' + (deadline.title === 'afin' ? 'Rent2Buy' : deadline.title))"> -->
            </div>

          </div>
          <div class="container-column_cards "
            [ngClass]="{'second-row-afin': deadline.title === 'afin' && i === 1}">
            <div class="card-term card-{{indexData}}"
              [ngClass]="{'comparative-card': i === 2, 'selected-card': checkSelectCard(deadline.title, item.type) }"
              *ngFor="let item of deadline.data; index as indexData"
              (click)="selectDeadline(deadline.title, item.values, true)">
              <div class="row-top">
                <p class="term">{{item.type}} meses</p>
                <h1 class="pay-month">{{item.values.monthlyPayment | currency}} <span class="text">Pago mensual</span></h1>
              </div>
              <div class="pay-init" *ngIf="selectConcept === 'ballon'">{{item.values.finalRate.ballon | currency}} <span class="value-text">Ballon</span></div>
              <div class="pay-init" *ngIf="selectConcept === 'traditional' && resDeadlines && resDeadlines?.includeAnnuities">{{resDeadlines.annuity | currency}} <span class="value-text">Anualidad</span></div>
              <div class="pay-init">{{item.values.initialPayment | currency}} <span class="value-text">Pago inicial</span></div>
              <div class="pay-init" >{{item.values.finalRate.finalRate | percent: '1.2-2'}} <span class="value-text">Tasa</span></div>
              <div class="pay-init" >{{item.values.cat | percent: '1.2-2'}} <span class="value-text">CAT</span></div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
  <div class="container-btn-autorize pt-30">
    <button (click)="preauthorize()" [disabled]="resultOfRequestNotSuccess() || !deadlineSelect" mat-raised-button
      id="boton-autorizar-plan{{isAfin ? '-rent2buy' : ''}}">¡QUIERO AUTORIZAR MI PLAN!</button>
  </div>
</section>